export const JWT_CONSTANTS = {
	/**
	 * The SECRET is used for signing and verifying JWTs. In production environments,
	 * this should be set via environment variables. The fallback value is provided
	 * for development purposes only.
	 */
	SECRET: process.env['JWT_SECRET'] ?? '8a9b36731918dd0766ba2f7a68b4a7ecde90e89ee31f006934956c49e4169264',
}
